import EmailSignInPage, { EmailSignInPageProps } from './EmailSignInPage';

export type { EmailSignInPageProps };
export default EmailSignInPage;
